module.exports = __webpack_public_path__ + "static/img/headerImg.c253d851.png";